var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("h1", [_vm._v(_vm._s(_vm.$t("signUpPage.confirmCode.title")))]),
      _vm.message
        ? _c("div", {
            staticClass: "message",
            domProps: { innerHTML: _vm._s(_vm.message) },
          })
        : _vm._e(),
      _vm.errorMessage
        ? _c("div", { staticClass: "error-message" }, [
            _vm._v(_vm._s(_vm.errorMessage)),
          ])
        : _vm._e(),
      _c("text-field", {
        staticClass: "input",
        attrs: {
          label: _vm.$t("signUpPage.confirmCode.label"),
          type: "text",
          icon: "password",
          placeholder: _vm.$t("signUpPage.confirmCode.placeholder"),
          maxlength: 6,
        },
        model: {
          value: _vm.confirmCode,
          callback: function ($$v) {
            _vm.confirmCode = $$v
          },
          expression: "confirmCode",
        },
      }),
      _c(
        "div",
        { staticClass: "button-container" },
        [
          _c(
            "button-default",
            {
              staticClass: "submit-button",
              attrs: {
                disabled: _vm.confirmCode.length !== 6 || _vm.submitting,
              },
              on: { click: _vm.submitConfirmCode },
            },
            [
              _vm.submitting
                ? _c(
                    "span",
                    { staticClass: "submit-button-content" },
                    [
                      _c("icon-spinner", {
                        staticClass: "submit-button-spinner",
                      }),
                      _vm._v(
                        " " +
                          _vm._s(_vm.$t("signUpPage.confirmCode.submitting")) +
                          " "
                      ),
                    ],
                    1
                  )
                : _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("signUpPage.confirmCode.submitButton"))
                    ),
                  ]),
            ]
          ),
        ],
        1
      ),
      _c("div", { staticClass: "setting" }, [
        _c(
          "a",
          {
            attrs: { href: "#" },
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.resend.apply(null, arguments)
              },
            },
          },
          [_vm._v(_vm._s(_vm.$t("signUpPage.confirmCode.resendLink")))]
        ),
        _c(
          "a",
          {
            attrs: {
              href: `${_vm.help}#a9ab790429a64fae9489d2ac06671565`,
              target: "_blank",
            },
          },
          [_vm._v(_vm._s(_vm.$t("signUpPage.confirmCode.helpLink")))]
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }